import React, {useEffect, useState} from "react";
import defaultImg from "@/pages/aigc/assets/svg/default-img.svg";
import {getLoadImage} from "@/pages/aigc/utils/utils";
import "./index.scss";


export default function (props:any) {
  const {src, className="", style={}, ...resetProps} = props;
  const [imgUrl, setImgUrl] = useState<any>(defaultImg);
  useEffect(() => {
    if (!src) return;
    getLoadImage(src).then(url => setImgUrl(url)).catch(e => {
      // console.error("图片加载失败: ", src);
    });
  }, [src]);
  const background = {
    backgroundImage: `url(${imgUrl})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: imgUrl != defaultImg ? 'cover' : '30% auto',
  };
  // imgUrl.includes("1686206283460_经分端时序") && console.log("** imgUrl", background, style)
	
  return (
    <div
      className={`aigc-img ${className}`}
      style={{...background , ...style}}
      {...resetProps}
    >
      {props.children}
    </div>
  );
}